module.exports = __webpack_public_path__ + "static/media/exclamation_warning.23ba93c0.svg";